import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const MAX_QTY = 10;

export function StoreProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("kc_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("kc_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id);
      if (existing) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, qty: Math.min(MAX_QTY, i.qty + qty) } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          slug: product.slug,
          image: (product.images || [])[0] || "",
          qty: Math.min(MAX_QTY, qty),
        },
      ];
    });
    toast.success(`${product.name} added to cart`);
    setOpen(true);
  };

  const setQty = (product_id, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.product_id !== product_id)
        : prev.map((i) => (i.product_id === product_id ? { ...i, qty: Math.min(MAX_QTY, qty) } : i))
    );

  const removeItem = (product_id) => {
    setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  };

  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  const shipping = subtotal === 0 || subtotal >= 1499 ? 0 : 79;
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <StoreContext.Provider
      value={{ items, addItem, setQty, removeItem, clear, subtotal, shipping, count, isOpen, setOpen }}
    >
      {children}
    </StoreContext.Provider>
  );
}
